export const ORDERS_QUERY_KEY = 'orders';
export const ORDER_QUERY_KEY = 'order';
